import React, { useState, useEffect } from 'react';
import { Form, Label } from 'semantic-ui-react';

/**
 * Single-field time input. Accepts/displays HH:MM:SS.mmm format.
 * Validates on blur and commits the parsed value.
 */
const TimeInput = ({
  label,
  labelColor = '#757575',
  labelAlign = 'left',
  value,
  onChange,
  minTime,
  maxTime,
}) => {
  const [text, setText] = useState(value || '00:00:00.000');
  const [error, setError] = useState(null);

  useEffect(() => {
    if (value) setText(value);
  }, [value]);

  const timeToSeconds = (time) => {
    const [hms, ms = '000'] = time.split('.');
    const [h = 0, m = 0, s = 0] = hms.split(':').map(Number);
    return h * 3600 + m * 60 + s + parseInt(ms, 10) / 1000;
  };

  const validate = (timeStr) => {
    if (!/^\d{2}:\d{2}:\d{2}\.\d{3}$/.test(timeStr)) {
      return 'Format: HH:MM:SS.mmm';
    }
    const [hms] = timeStr.split('.');
    const [h, m, s] = hms.split(':').map(Number);
    if (h > 23) return 'Hours: 00-23';
    if (m > 59) return 'Minutes: 00-59';
    if (s > 59) return 'Seconds: 00-59';
    if (minTime && timeToSeconds(timeStr) < timeToSeconds(minTime)) {
      return `Must be ≥ ${minTime}`;
    }
    if (maxTime && timeToSeconds(timeStr) > timeToSeconds(maxTime)) {
      return `Must be ≤ ${maxTime}`;
    }
    return null;
  };

  const handleBlur = () => {
    const err = validate(text);
    setError(err);
    if (!err) {
      onChange(text);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.target.blur();
    }
  };

  return (
    <Form.Field error={!!error} className="trimmer-time-field">
      {label && (
        <label
          style={{
            color: labelColor,
            lineHeight: '14px',
            fontSize: '0.9em',
            textAlign: labelAlign,
          }}
        >
          {label}
        </label>
      )}
      <input
        type="text"
        className="trimmer-time-input"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        onFocus={(e) => e.target.select()}
        size={14}
        placeholder="00:00:00.000"
      />
      {error && (
        <Label basic color="red" pointing>
          {error}
        </Label>
      )}
    </Form.Field>
  );
};

export default TimeInput;
